import { Component, OnInit, Output } from '@angular/core';
import { Prize, Draw } from '@app/_models/giveaway';
import { GiveawayService } from '@app/services/giveaways/giveaways.service';
import { EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Utilities from '@app/_helpers/utilities';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'giveaway-new-prize',
  templateUrl: './giveaway-new-prize.component.html',
  styleUrls: ['./giveaway-new-prize.component.scss']
})
export class GiveawayNewPrizeComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private giveawayService: GiveawayService,
    private builder: FormBuilder,
    private _snackBar: MatSnackBar
  ) { }

  @Output() onAddedDraws: EventEmitter<Draw[]> = new EventEmitter();
  isPrizeListHidden = false;
  prizes: Array<Prize> = [];
  selectedPrizes: Array<Prize> = [];
  newPrizeImgReview: string;
  newPrizeForm = this.builder.group({
    name: ['', Validators.required],
    image: ['', Validators.required],
  });

  ngOnInit(): void {
    this.giveawayService.getPrizes().subscribe((res: Array<Prize>) => {
      this.prizes = res;
    });
  }

  async handleFileInput(image: File): Promise<any> {
    this.newPrizeImgReview = await Utilities.toBase64(image)
    this.newPrizeForm.patchValue({
      image: image,
    })
  }

  uploadNewProzeImage(): void {
    document.getElementById('fileInput').click();
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  showNewPrize(): void {
    this.isPrizeListHidden = true;
  }
  saveNewPrize(action): void {
    if (action) {
      const newPrize = new FormData();
      newPrize.append('name', this.newPrizeForm.value.name);
      newPrize.append('image', this.newPrizeForm.value.image);
      this.giveawayService.createPrize(newPrize).subscribe((res: Prize) => {
        this.prizes.push(res);
        this.newPrizeForm.reset()
        this.newPrizeImgReview = '';
        this.isPrizeListHidden = false;
      }, (err) => {
        this._snackBar.open(err, '', {
          duration: 3000,
        });
      });
    }
  }

  addNewPrizesToGiveaway(): void {
    const draws: Draw[] = [];
    this.selectedPrizes.forEach((prize: Prize) => {
      draws.push({
        prize: prize.id,
        prizeDetail: prize,
      })
    })
    this.onAddedDraws.emit(draws);
    this.dialog.closeAll();
  }

  selectPrize(prize: Prize, target: Element): void {
    if (target.classList.contains('active')) {
      target.classList.remove('active')
      this.selectedPrizes = this.selectedPrizes.filter((e) => {
        e.id !== prize.id;
      })
    } else {
      target.classList.add('active');
      this.selectedPrizes.push(prize);
    }
  }
}
